const pannelWidth = 715;
const pannelHeight = 560;

const artBuilder = (imageURL, cardType) => {
	const canvas = document.createElement("canvas");
	canvas.height = pannelHeight;
	canvas.width = pannelWidth;
	const ctx = canvas.getContext("2d");
	ctx.clearRect(0, 0, canvas.width, canvas.height);
	const isSaga = cardType.indexOf("Saga") > -1 ? true : false;
	const isBattle = cardType.indexOf("Battle") > -1 ? true : false;

	//console.log(`Art ${isSaga ? "is" : "is not"} a saga`);

	// draw the image with 90% opacity
	return new Promise((res, rej) => {
		const art = document.createElement("img");
		art.crossOrigin = "Anonymous";
		art.src = isBattle ? imageURL.art_crop : imageURL.large;
		art.onload = () => {
			res(art);
		};
		art.onerror = () => {
			rej("Error getting image art");
		};
	})
		.then((img) => {
			ctx.globalAlpha = 0.35;
			if (isSaga) {
				//ctx.drawImage(image, source_x, source_y, source_Width, source_Height, dx, dy, dWidth, dHeight);
				ctx.drawImage(img, 340, 110, 280, 280, 29, 165, 655, 325);
			} else if (isBattle) {
				ctx.drawImage(img, 340, 110, 280, 200, 29, 165, 655, 325);
			} else {
				ctx.drawImage(img, 60, 110, 550, 300, 29, 165, 655, 325);
			}
			return canvas.toDataURL("image/png");
		})
		.catch((err) => {
			return canvas.toDataURL("image/png");
		});
};

export default artBuilder;
